import { Controller } from "@hotwired/stimulus"

// Clicking the task dot expands into Done / Won't Do choices
export default class extends Controller {
  static targets = ["tap", "choices"]

  expand(event) {
    event.preventDefault()
    this.tapTarget.hidden = true
    this.choicesTarget.hidden = false
  }

  // Collapse back if user clicks outside
  collapse(event) {
    if (!this.element.contains(event.target)) {
      this.tapTarget.hidden = false
      this.choicesTarget.hidden = true
    }
  }

  connect() {
    this._outsideClick = this.collapse.bind(this)
    document.addEventListener("click", this._outsideClick)
  }

  disconnect() {
    document.removeEventListener("click", this._outsideClick)
  }
}
